module.exports = __webpack_public_path__ + "img/zs3-icon.2b860c9e.png";